<template>
  <div class="mySubs">
      <div class="content">
          <div class="current-loc">
            <span>{{ $t('satellite.CurrentPosition') }}：</span>
            <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>{{ $t('personalCenter.myCollection') }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <p class="title">{{ $t('personalCenter.myCollection') }}</p>
          <hr>
          <div class="query">
              <el-button size="mini" @click="cancelSubMore">{{ $t('personalCenter.cancelCollection') }}</el-button>
          </div>
          <div class="data-table">
              <el-table
                :header-cell-style="header_cell_style_bd"
                :cell-style="cell_style_bd"
                :style="cell_style_bd"
                :data="tableData"
                :empty-text="$t('Intelligent.NoData')"
                ref="tableList"
                border>
                <el-table-column
                type="selection"
                width="55">
                </el-table-column>
                <el-table-column
                prop="collectTime"
                :label="$t('personalCenter.Subscribetothetime')"
                width="200"
                align="center">
                </el-table-column>
                <el-table-column
                prop="subscribeProductName"
                :label="$t('DataSubmission.ProductName')"
                align="center">
                    <template slot-scope="scope">
                        <span @click="goDetail(scope.row)" >{{scope.row.collectProductName}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                :label="$t('DataSubmission.Operation')"
                width="100"
                align="center">
                    <template slot-scope="scope">
                        <span @click="cancel([scope.row.pkid])" >{{ $t('DataSubmission.Cancel') }}</span>
                    </template>
                </el-table-column>
            </el-table>
          </div>
          <div class="pagenation">
                <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                @current-change="currentChange"
                :page-size="10">
                </el-pagination>
          </div>
      </div>
  </div>
</template>

<script>
import {
    getCollectList,
    cancelCollect
    } from "@/api/product/index"
import { mapGetters} from "vuex";
export default {
    name:'mySubs',
    components: {
    },
    data(){
        return{
            pageOption:{
                limit:10,
                page:1
            },
            total:0,
            tableData:[]
        }
    },
    watch:{
    },
    created(){
        this.getList()
    },
    computed:{
        ...mapGetters(['header_cell_style_bd','cell_style_bd']),
    },
    methods:{
        currentChange(val){
            this.pageOption.page = val
            this.getList()
        },
        goDetail(val){
            window.parent.postMessage({router:val},"*")
        },
        cancelSubMore(){
            let a = this.$refs.tableList.selection
            let c = a.map(item => item.pkid)
            this.cancel(c)
        },
        async cancel(val){
            let that = this
            let params = {
                pkIds:val
            }
            let res = await cancelCollect(params)
            if(res.code=='000000'){
                that.$message.success('取消收藏成功')
                that.getList()
            }
        },
        async getList(){
            let that = this
            let res = await getCollectList(that.pageOption)
            that.tableData = res.data.list
            that.total = parseInt(res.data.totalCount)
        }
    }
}
</script>

<style lang="scss" scoped>
hr{
    @include hr_white_to_black();
}
.current-loc{
    height: 21px;
    display: flex;
    align-items: center;
    /deep/ span{
        font-size: 15px;
        @include co_white_to_black();
    }
    /deep/ a{
        @include co_white_to_black();
    }
    /deep/ .el-breadcrumb__item:last-child{
        span{
            color: rgba(38,125,255,1);
        }
    }
}
.mySubs{
    width: 100%;
    @include table_page_bg();
    .content{
        min-height: 600px;
        margin: 0 auto;
        padding: 0 12px;
        padding-bottom: 12px;
        .label{
            margin: 60px 0 20px 0;
        }
        .title{
            font-size: 28px;
            color: rgba(39,121,202,1);
            margin: 20px 0;
        }
        .query{
            display: flex;
            align-items: center;
            font-size: 15px;
            margin: 20px 0;
            .search{
                width: 240px;
                margin: 0 12px;
            }
            .search-btn{}
        }
        .data-table{
            margin: 20px 0;
            .mySubs-status1{
                width: 8px;
                height: 8px;
                border-radius: 50px;
                background: green;
                margin-right: 8px
            }
            .mySubs-status2{
                @extend .mySubs-status1;
                background: rgba(24,144,255,1);
            }
            .mySubs-status3{
                @extend .mySubs-status1;
                background: rgba(215,218,225,1);
            }
            .mySubs-status{
            }
        }
        .pagenation{
            display: flex;
            justify-content: flex-end;
            padding-right: 0;
        }
    }
    ::v-deep .btn-next{
        margin-right: 0;
    }
    ::v-deep .el-pagination{
        padding-right: 0;
    }
}
.down-dialog-main{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .down-dialog-site{
        margin-bottom: 12px;
        span{
            display: inline-block;
            width: 100px;
            text-align: right;
        }
        
    }
}
</style>
